import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 bg-[var(--color-slate-blue)] text-white px-4 py-2 rounded">
        Skip to main content
      </a>
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" aria-label="Main navigation">
          <div className="flex h-20 justify-between items-center">
            <div className="flex-shrink-0">
              <Link to="/" className="text-2xl font-bold text-[var(--color-slate-blue)] hover:no-underline">
                Northbridge HVAC
              </Link>
            </div>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-[var(--color-text-dark)] hover:text-[var(--color-slate-blue)] transition-colors">
                Home
              </Link>
              <Link to="/about" className="text-[var(--color-text-dark)] hover:text-[var(--color-slate-blue)] transition-colors">
                About
              </Link>
              <Link to="/services" className="text-[var(--color-text-dark)] hover:text-[var(--color-slate-blue)] transition-colors">
                Services
              </Link>
              <Link to="/service-area" className="text-[var(--color-text-dark)] hover:text-[var(--color-slate-blue)] transition-colors">
                Service Area
              </Link>
              <Link to="/blog" className="text-[var(--color-text-dark)] hover:text-[var(--color-slate-blue)] transition-colors">
                Blog
              </Link>
              <Link to="/contact" className="text-[var(--color-text-dark)] hover:text-[var(--color-slate-blue)] transition-colors">
                Contact
              </Link>
              <a 
                href="tel:9055550142" 
                className="flex items-center gap-2 bg-[var(--color-warm-amber)] text-white px-4 py-2 rounded hover:bg-opacity-90 transition-colors"
                aria-label="Call us at (905) 555-0142"
              >
                <Phone size={18} />
                <span className="font-medium">(905) 555-0142</span>
              </a>
            </div>

            <button
              onClick={toggleMobileMenu}
              className="md:hidden p-2 rounded text-[var(--color-text-dark)]"
              aria-expanded={isMobileMenuOpen}
              aria-label="Toggle navigation menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {isMobileMenuOpen && (
            <div className="md:hidden py-4 border-t">
              <div className="flex flex-col space-y-2">
                <Link 
                  to="/" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-2 text-[var(--color-text-dark)] hover:bg-[var(--color-neutral-bg)]"
                >
                  Home
                </Link>
                <Link 
                  to="/about" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-2 text-[var(--color-text-dark)] hover:bg-[var(--color-neutral-bg)]"
                >
                  About
                </Link>
                <Link 
                  to="/services" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-2 text-[var(--color-text-dark)] hover:bg-[var(--color-neutral-bg)]"
                >
                  Services
                </Link>
                <Link 
                  to="/service-area" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-2 text-[var(--color-text-dark)] hover:bg-[var(--color-neutral-bg)]"
                >
                  Service Area
                </Link>
                <Link 
                  to="/blog" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-2 text-[var(--color-text-dark)] hover:bg-[var(--color-neutral-bg)]"
                >
                  Blog
                </Link>
                <Link 
                  to="/contact" 
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-2 text-[var(--color-text-dark)] hover:bg-[var(--color-neutral-bg)]"
                >
                  Contact
                </Link>
                <a 
                  href="tel:9055550142" 
                  className="mx-4 flex items-center justify-center gap-2 bg-[var(--color-warm-amber)] text-white px-4 py-2 rounded"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <Phone size={18} />
                  <span className="font-medium">(905) 555-0142</span>
                </a>
              </div>
            </div>
          )}
        </nav>
      </header>
    </>
  );
}